import { CaptureResult } from 'posthog-js'

const redactedProperties = [
  'name',
  'email',
  'nin',
  'insuranceNumber',
  'birthday',
]

const filterProperties = (objectToSend: Record<string, unknown>) =>
  Object.entries(objectToSend).reduce(
    (acc, [key, value]) => {
      if (
        redactedProperties.some((prop) =>
          key.toLowerCase().includes(prop.toLowerCase()),
        )
      ) {
        acc[key] = null
      } else {
        acc[key] = value
      }

      return acc
    },
    {} as Record<string, unknown>,
  )

export const beforeSend = (event: CaptureResult | null) => {
  if (!event) {
    return null
  }

  event.properties = filterProperties(event.properties)
  event.$set = filterProperties(event.$set ?? {})
  event.$set_once = filterProperties(event.$set_once ?? {})

  return event
}
